import cloneDeep from 'lodash/cloneDeep';
import * as allTypes from '@/store/mutation-type';
import getAll from '@/api/ligneCommandeView';
import genererCritereRechercheLignesFacture
  from '@/services/bodac/lignesFacture/genererCritereRechercheLignesFacture';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import { DEVIS_COMMANDE_ETAT } from '@/configuration/devisConf';
import transformer from '@/services/ligneCommande/ligneDcfServerTableDataTransformer';
import * as types from '@/store/modules/bodac/factureParLigne-mutation-type';

function initialState() {
  return {
    items: [],
    totalCount: 0,
    criteresRecherche: cloneDeep(genererCritereRechercheLignesFacture()),
    lastPayload: {},
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_ITEMS](state, items) {
    state.items = items;
  },
  [types.SET_TOTAL](state, count) {
    state.totalCount = count;
  },
  [types.SET_CRITERE](state, critere) {
    state.criteresRecherche = critere;
  },
  [types.SET_LAST_PAYLOAD](state, payload) {
    state.lastPayload = payload;
  },
  [types.RESET_CRITERE](state) {
    state.criteresRecherche = cloneDeep(genererCritereRechercheLignesFacture());
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async loadLignesFacture({ commit }, search) {
    const dataToSend = transformer(cloneDeep(search));
    commit(types.SET_LAST_PAYLOAD, dataToSend);
    const data = (await getAll(dataToSend)).data.result;
    data.items.forEach((ligne) => {
      if (ligne.commercialId) {
        ligne.nomCommercial = nomPrenomGetter({
          nom: ligne.commercialNom,
          prenom: ligne.commercialPrenom,
        });
      }
      const etat = DEVIS_COMMANDE_ETAT.find((etatInList) => {
        return etatInList.code === ligne.etatDcf;
      });
      ligne.etatLibelle = etat ? etat.libelle : '';
    });
    commit(types.SET_ITEMS, data.items);
    commit(types.SET_TOTAL, data.totalCount);
    return {};
  },
};

const getters = {
  items: state => {
    return state.items;
  },
  totalCount: state => {
    return state.totalCount;
  },
  criteresRecherche: state => {
    return state.criteresRecherche;
  },
  lastPayload: state => {
    return state.lastPayload;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
